(function(){
  document.addEventListener('click', function(e){
    var pill = e.target.closest('.pr_card_pill');
    if(!pill || pill.getAttribute('data-available') === 'false') return;
    var card = pill.closest('.pr_card_v2');
    if(!card) return;
    var atc = card.querySelector('.pr_card_atc.js_addtc');
    if(atc){ atc.setAttribute('data-id', pill.getAttribute('data-variant-id')); }
    card.querySelectorAll('.pr_card_pill').forEach(function(p){ p.classList.remove('is-active'); });
    pill.classList.add('is-active');
  });
})();
